import { Component, Output, EventEmitter, Input } from '@angular/core';
import { SkipInteraction } from '@shared/store';

@Component({
  selector: 'app-media',
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.scss'],
  standalone: false
})
export class MediaComponent {
  public readonly interaction = SkipInteraction.CameraConsentPage;

  @Input() showBrowserProblemLink: boolean = false;
  @Output() confirmMedia = new EventEmitter<void>();

  public confirm() {
    this.confirmMedia.emit();
  }

}
